import React, { memo } from 'react';
import './footer.scss';
import '../../styles/App.css'

function Disclaimer() {
    const sentence1 = `Vodafone Group Plc. 
    Registered Office: Vodafone House. 
    The Connection, Newbury, Berkshire RG14 2FN. Registered in England No 1833679`;
    const sentence2 = `We use cookies to improve your experience on this site.`
    return (
        <>
            <div className='content boxSize'>
                <p className='SWA-disclaimer-text'>{sentence1}</p>
                <p className='SWA-disclaimer-text'>{sentence2}
                    <a className={'SWA-disclaimer-link'}
                        href="https://www.vodafone.de/unternehmen/soziale-verantwortung/datenschutz-privatsphaere.html">
                        &nbsp;Read our policy</a></p>
            </div>
        </>
    )
}

export default memo(Disclaimer)